<template>
  <div v-if="races && races.length">
    <Alert
      v-if="showOnlineMessage"
      class="event-races-alert"
      icon="global"
    >
      <template v-slot:text>
        <div class="alert__text">
          <span v-html="$t('aboutOnlineAlert.text')"></span>
          <button class="link" @click="$emit('click:aboutOnline')">{{ $t('aboutOnlineAlert.button') }}</button>.
        </div>
      </template>
    </Alert>
    <table class="event-races" v-if="!groupByDay">
      <tbody>
      <event-race
        v-for="race in races"
        :key="race.c"
        :utcCurrentTime="utcCurrentTime"
        :scountInfo="scountInfo"
        class="event-races__item"
        :event="event"
        :race="race"
        :raceDynamicInfo="dynamicRacesById[race.id]"
        :type="type"
        :finished="finished"
        v-bind="raceProps"
      ></event-race>
      </tbody>
    </table>
    <table class="event-races" v-else>
      <template v-if="isRzd">
        <template v-for="(group, date, i) in racesByDay">
          <EventRacesHeadRow
            :key="date"
            :dateISO="date"
            :event="event"/>
          <tbody :key="`body-${i}`">
            <template v-for="(races, time) in group">
              <EventRacesRzdRow
                v-if="isRzd"
                :key="time"
                :time="time"
              />
              <event-race
                v-for="race in races"
                :key="race.c"
                :utcCurrentTime="utcCurrentTime"
                :scountInfo="scountInfo"
                class="event-races__item"
                :event="event"
                :race="race"
                :raceDynamicInfo="dynamicRacesById[race.id]"
                :type="type"
                :finished="finished"
                v-bind="raceProps"
              ></event-race>
            </template>
          </tbody>
        </template>
      </template>
      <template v-else>
        <template v-for="(races, date, i) in racesByDay">
          <EventRacesHeadRow
            :key="date"
            :dateISO="date"
            :event="event"
          />
          <tbody :key="`body-${i}`">
            <event-race
              v-for="race in races"
              :key="race.c"
              :utcCurrentTime="utcCurrentTime"
              :scountInfo="scountInfo"
              class="event-races__item"
              :event="event"
              :race="race"
              :raceDynamicInfo="dynamicRacesById[race.id]"
              :type="type"
              :finished="finished"
              v-bind="raceProps"
            ></event-race>
          </tbody>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
import { groupBy, orderBy } from 'lodash';
import Alert from '@/components/Alert.vue';
import EventRace from './EventRace.vue';
import EventRacesHeadRow from './EventRacesHeadRow.vue';
import EventRacesRzdRow from './EventRacesRzdRow.vue';

export default {
  name: 'EventRaces',
  components: {
    Alert,
    EventRace,
    EventRacesHeadRow,
    EventRacesRzdRow,
  },
  props: {
    type: String,
    races: Array,
    dynamicRacesById: Object,
    finished: Boolean,
    event: Object,
    scountInfo: Object,
    groupByDay: Boolean,
    raceProps: Object,
    utcCurrentTime: String,
  },
  computed: {
    isRzd() {
      return window.RR_APP_TENANT === 'rzd';
    },
    showOnlineMessage() {
      return (this.races || []).some((o) => o.ivr);
    },
    racesByDay() {
      const grouped = groupBy(this.races || [], (o) => {
        const d = o.hrd ? null : o.sd || this.event?.BeginDate;
        return !d
          ? 'no-date'
          : this.$moment.utc(d)
            .set({
              hour: 0,
              minute: 0,
              second: 0,
            })
            .format()
            .slice(0, -1);
      });

      const sortedKeys = orderBy(Object.keys(grouped), (key) => (
        (key === 'no-date')
          ? 0
          : +new Date(key)
      ));

      const sortedByDay = sortedKeys.reduce((obj, key) => ({
        ...obj,
        [key]: grouped[key],
      }), {});

      if (!this.isRzd) return sortedByDay;

      const sortedByDayAndTime = Object.entries(sortedByDay).map(([date, races]) => {
        races.sort((prevRace, nextRace) => new Date(prevRace.sd).getTime() - new Date(nextRace.sd).getTime());

        const racesByTime = races.reduce((acc, race) => {
          const startDayTime = new Date(race.sd);
          const timeFormatter = Intl.DateTimeFormat('ru', {
            hour: 'numeric',
            minute: 'numeric',
          });

          const timeRace = timeFormatter.format(startDayTime);

          acc[timeRace] = acc[timeRace] ?? [];
          acc[timeRace].push(race);

          return acc;
        }, {});

        return [date, racesByTime];
      });

      return Object.fromEntries(sortedByDayAndTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.event-races-alert {
  margin-bottom: 24px;
}

table.event-races {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px;
  table-layout: auto;
}

.event-races {
  margin: -12px 0;

  &__item {

    &:nth-child(odd) {
      background-color: $color-black-2;
    }
  }
}
</style>
